<template>
  <div class="evaluation-record-page" v-loading="loading">
    <div class="page-inner">
      <div class="record-header">
        <div class="title-group">
          <el-button type="text" icon="el-icon-back" class="back-btn" @click="handleBack">返回</el-button>
          <div class="page-title">考核记录</div>
        </div>
        <span class="status-text" :class="statusClass">{{ statusText }}</span>
      </div>

      <el-table
        :data="recordList"
        class="record-table"
        empty-text="暂无数据"
        style="width: 100%"
      >
        <el-table-column label="序号" width="120" align="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="考试名称" min-width="320">
          <template slot-scope="scope">
            {{ getCategoryName(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column label="考试分数" width="180" align="left">
          <template slot-scope="scope">
            {{ getScoreText(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column label="满分" width="180" align="left">
          <template slot-scope="scope">
            {{ getFullMarkText(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  name: "EvaluationRecord",
  data() {
    return {
      loading: false,
      arId: null,
      record: null,
      recordList: []
    };
  },
  computed: {
    statusText() {
      if (!this.record) {
        return "待考核";
      }
      const score = Number(this.record.score);
      const proportion = Number(this.record.proportion);
      const passProportion = Number(this.record.passProportion);
      if (!Number.isNaN(proportion) && !Number.isNaN(passProportion)) {
        if (proportion >= passProportion) {
          return "已通过";
        }
        return "未通过";
      }
      if (Number.isNaN(score)) {
        return "待考核";
      }
      return score >= 60 ? "已通过" : "未通过";
    },
    statusClass() {
      if (this.statusText === "已通过") {
        return "is-pass";
      }
      if (this.statusText === "未通过") {
        return "is-fail";
      }
      return "is-pending";
    }
  },
  created() {
    this.initPage();
  },
  methods: {
    parsePositiveInt(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        return null;
      }
      return num;
    },
    async initPage() {
      this.arId = this.parsePositiveInt(this.$route.query.arId);
      if (!this.arId) {
        this.$message.warning("考核记录参数异常");
        this.record = null;
        this.recordList = [];
        return;
      }
      await this.loadData();
    },
    async loadData() {
      this.loading = true;
      try {
        const res = await httpRequest("/app/train/practice/check/checks", "get", {
          arId: this.arId
        });
        if (res && res.code === 200 && res.data) {
          this.record = res.data;
          this.recordList = Array.isArray(res.data.categorys)
            ? res.data.categorys
            : [];
        } else {
          this.record = null;
          this.recordList = [];
        }
      } catch (error) {
        void error;
        this.record = null;
        this.recordList = [];
      } finally {
        this.loading = false;
      }
    },
    getCategoryName(row) {
      if (!row || !row.category) {
        return "-";
      }
      return row.category.name || "-";
    },
    getScoreText(row) {
      if (!row || row.score === null || row.score === undefined) {
        return "-";
      }
      const score = Number(row.score);
      if (Number.isNaN(score)) {
        return String(row.score);
      }
      return Number.isInteger(score) ? `${score}` : score.toFixed(2);
    },
    getFullMarkText(row) {
      if (!row || !row.category) {
        return "-";
      }
      const fullMark = Number(row.category.fullMark);
      if (Number.isNaN(fullMark)) {
        return row.category.fullMark || "-";
      }
      return Number.isInteger(fullMark) ? `${fullMark}` : fullMark.toFixed(2);
    },
    handleBack() {
      // 若是通过带有 arId 参数跳转过来，可以原路返回，也可以指定返回上一页
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
.evaluation-record-page {
  min-height: calc(100vh - 77px - 56px);
  background: #f5f7fa;
  padding: 28px 0 36px;

  .page-inner {
    width: 1200px;
    max-width: calc(100% - 60px);
    margin: 0 auto;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 30px 40px;
  }

  .record-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #ebeef5;
  }

  .title-group {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .back-btn {
    font-size: 16px;
    color: #606266;
    padding: 0;

    &:hover {
      color: #3f8fe9;
    }
  }

  .page-title {
    font-size: 22px;
    line-height: 1;
    color: #303133;
    font-weight: 600;
  }

  .status-text {
    font-size: 16px;
    line-height: 1;
    font-weight: 500;

    &.is-pending {
      color: #e6a23c;
    }

    &.is-pass {
      color: #67c23a;
    }

    &.is-fail {
      color: #f56c6c;
    }
  }

  ::v-deep .record-table {
    .el-table__header th {
      background: #fafafa;
      color: #606266;
      font-size: 15px;
      font-weight: bold;
      border-bottom: 1px solid #ebeef5;
      padding: 12px 0;
    }

    .el-table__body td {
      color: #606266;
      font-size: 14px;
      border-bottom: 1px solid #ebeef5;
      padding: 12px 0;
    }

    .el-table__empty-text {
      color: #909399;
      font-size: 14px;
      line-height: 1;
    }
  }
}
</style>
